import React, { useRef, useEffect, useState } from 'react';

const periods = [1, 3, 6, 12];

export function PeriodSelector({ selectedPeriod, onPeriodChange }) {
    const containerRef = useRef(null);
    const periodRefs = {
        1: useRef(null),
        3: useRef(null),
        6: useRef(null),
        12: useRef(null)
    };
    const [highlightStyle, setHighlightStyle] = useState({ left: 0, width: 0 });

    useEffect(() => {
        if (containerRef.current && periodRefs[selectedPeriod]?.current) {
            const containerRect = containerRef.current.getBoundingClientRect();
            const activeRect = periodRefs[selectedPeriod].current.getBoundingClientRect();
            setHighlightStyle({
                left: activeRect.left - containerRect.left,
                width: activeRect.width
            });
        }
    }, [selectedPeriod]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (containerRef.current && periodRefs[1]?.current) {
                const containerRect = containerRef.current.getBoundingClientRect();
                const activeRect = periodRefs[1].current.getBoundingClientRect();
                setHighlightStyle({
                    left: activeRect.left - containerRect.left,
                    width: activeRect.width
                });
            }
        }, 0);
        return () => clearTimeout(timeout);
    }, []);

    return (
        <div className="v1_93" ref={containerRef}>
            <div
                className="active-highlight"
                style={{ left: highlightStyle.left, width: highlightStyle.width }}
            />
            {periods.map(period => (
                <div
                    key={period}
                    className="period-item"
                    ref={periodRefs[period]}
                    onClick={() => onPeriodChange(period)}
                >
                    <span className="period-text">{period} мес</span>
                </div>
            ))}
        </div>
    );
}